// Lead Generation System — the EXTERNAL console's grade + bonus-multiplier
// client. Kept in its OWN file (never in leadGenerator.ts) so the prelead-FE
// workstream that owns leadGenerator.ts is untouched.
//
// Mirrors the C# record LeadGenGradeResult (ILeadGenGradeService.cs) and the
// route GET api/portal/lead-generator/grade on PortalLeadGeneratorController.
// The grade is the SAME engine the internal earnings page reads, so the badge
// number matches everywhere. DISPLAY-ONLY: the manager pays off-system.

import { portalApi } from "./client";

/** The computed grade for the signed-in generator + a pay week. All decimals
 *  serialize as JSON numbers. `band` is the base letter (A/B/C/D/F); `letter`
 *  carries the +/- (e.g. "A-", "B", "A+", "F"). */
export interface LeadGenGradeResult {
  /** The Monday (UTC) of the pay week this grade is for. */
  weekOf: string;
  /** Approved KPI-earned credits ÷ total weekly cap, ×100 (may exceed 100). */
  gradePercent: number;
  /** Display letter with +/- (e.g. "A-", "B", "A+", "F"). */
  letter: string;
  /** Base letter band (A/B/C/D/F) that drives the multiplier + color. */
  band: string;
  /** The bonus multiplier (>= 1.00 — upside only). */
  multiplier: number;
  /** The plan's total weekly cap used as the grade denominator. */
  weeklyCap: number;
  /** Approved KPI-earned credits (net of caps) — the multiplier base. */
  approvedGross: number;
  /** Sum of the week's approved signed manual adjustments. */
  totalAdjustments: number;
  /** Round(gross × multiplier) + adjustments — the payable figure. */
  approvedNet: number;
  /** Next higher band letter (null when already maxed). */
  nextLetter: string | null;
  /** The multiplier at {@link nextLetter}. */
  nextMultiplier: number;
  /** Additional KPI-earned dollars to reach the next band (0 when maxed). */
  distanceToNext: number;
}

const BASE = "/lead-generator";

export const leadGenGradeApi = {
  /** The generator's own weekly grade. Defaults (no arg) to the current pay
   *  week (Monday, UTC); pass an ISO instant to page back to that week. */
  grade: (weekOf?: string | null) =>
    portalApi.get<LeadGenGradeResult>(`${BASE}/grade`, weekOf ? { weekOf } : undefined),
};
